import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

export const RecurringRequestListModel = t.model('RecurringRequestListModel', {
  id: t.string,
  enrollment_id: t.string,
  enrollment_type_id: t.string,
  reference_number: t.string,
  biller_alias_name: t.string,
  merchant_id: t.string,
  merchant_name: t.string,
  wallet_id: t.string,
  full_name: t.string,
  mobile_no: t.string,
  amount: t.number,
  currency_code: t.string,
  sof: t.string,
  frequency: t.string,
  payment_at: t.number,
  status: t.string,
  reason: t.maybeNull(t.string),
  remind_me_at: t.number,
  recurring_type: t.string,
  pending_at: t.string,
  approved_at: t.string,
  rejected_at: t.string,
  rejected_by: t.string,
  description: t.string,
  created_at: t.string,
  created_by: t.string,
  updated_at: t.string,
  updated_by: t.string,
});

export const RecurringRequestModel = t
  .model('RecurringRequestModel', {
    list: t.array(RecurringRequestListModel),
    pagination: t.model('Pagination', {
      total_count: t.optional(t.number, 0),
      current_page: t.optional(t.number, 0),
      total_pages: t.optional(t.number, 0),
    }),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default RecurringRequestModel;
